export const base64ToUint8Array = (value) => {
  if (!value) return null;
  if (value instanceof Uint8Array) return value;
  if (value instanceof ArrayBuffer) return new Uint8Array(value);

  const base64 = String(value).replace(/-/g, '+').replace(/_/g, '/');
  const paddedBase64 = `${base64}${'='.repeat((4 - (base64.length % 4)) % 4)}`;
  return Uint8Array.from(atob(paddedBase64), (char) => char.charCodeAt(0));
};

export const bufferToBase64 = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));

export const getAssertionPayload = (credential) => ({
  id: credential.id,
  rawId: bufferToBase64(credential.rawId),
  type: credential.type,
  response: {
    clientDataJSON: bufferToBase64(credential.response.clientDataJSON),
    authenticatorData: bufferToBase64(credential.response.authenticatorData),
    signature: bufferToBase64(credential.response.signature),
    userHandle: credential.response.userHandle
      ? bufferToBase64(credential.response.userHandle)
      : null,
  },
});
